export default {
  data() {
    return {
      isVideoEditable: false,
      showVideoDetail: false,
      showVideoLibrary: false,
      videoClicked: null,
      IMAGE_REGEX: new RegExp(' *{{img_media_[\\d]{1,}}} *', 'g'),
    };
  },
  methods: {
    handleActivateVideoEdit() {
      this.isVideoEditable = true;
    },
    handleVideoLibrary() {
      this.showVideoLibrary = true;
      this.showVideoDetail = false;

      this.openSlideDrawer();
    },
    handleShowVideo(selectedVideoObj, isEditable = false) {
      this.videoClicked = { ...selectedVideoObj };

      this.openSlideDrawer();

      this.showVideoDetail = true;
      this.showVideoLibrary = false;
      this.isVideoEditable = isEditable;
    },
    // helper functions.
    // used in Email, Text composers.
    formatVideoTitle(title) {
      // below regex matches v1 method to ensure compatibility
      return title.trim().replace(/[\s_]/gi, '-').replace(/[^\w-]/gi, '').replace(/-{2,}/gi, '-');
    },
    formatInsertVideo(selectedVideo) {
      return `{{mediavideo_${selectedVideo.id}_${this.formatVideoTitle(selectedVideo.title)}}}`;
    },
    evaluateVideoStatus(video) {
      // Whether we show a videoThumbnail, processing Icon or broken image icon depends
      // on the video status, Or the timestamp for when the video was created.
      // The status can be either "COMPLETE" or an empty "".

      const dateMinusFive = new Date();
      dateMinusFive.setMinutes(dateMinusFive.getMinutes() - 5);

      if (video.status === 'COMPLETE') {
        return video.status;
      }

      // If the video was created within the last 5 minutes show "PROCESSING"
      if (video.created_at > dateMinusFive.toISOString()) {
        return 'PROCESSING';
      }

      // If video status hasn't become "Complete" after five minutes,
      // we are assuming the upload "failed".
      return 'FAILED';
    },
    getImagesURLsInSMS(imagesMetadata, smsBody) {
      const mediaVariables = smsBody.replace(/\s/g, '').match(this.IMAGE_REGEX);
      if (!mediaVariables) return [];
      return imagesMetadata
        .filter(image => mediaVariables.includes(image.alias))
        .map(image => image.url);
    }
  },
};
